// Packages
import { useTheme } from "@mui/material/styles";

// MUI
import {
  Box,
  Typography,
  Tooltip,
} from "@mui/material";

// Zustand
import useZustandStore from "zustandStore";

// Icon
import icon_info from "assets/images/icons/icn_Info_solid.svg";
import icon_info_hover from "assets/images/icons/icn_info_solid_hover.svg";
import { ReactComponent as ProColorIcon } from "assets/images/icons/icn-pro.svg";
import { ReactComponent as ProOrangeOutlineIcon } from "assets/images/icons/icn_Pro_orange_outline.svg";

export const StyledLabel = ({
  isIndent = false,
  label = "",
  tooltip,
  isPro = false,
  isProEnabled = false,
  children
}) => {
  const theme = useTheme();
  const isUnityProSubscribed = useZustandStore((state) => state.isUnityProSubscribed);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        ml: isIndent ? 2.5 : 1,
        mt: 2.3,
        color: theme.palette.primary.main,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.customFontSize[5],
        fontWeight: theme.typography.customFontWeight[3],
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          minWidth: "330px",
          color: theme.palette.primary.greyPrimary,
          fontSize: theme.typography.customFontSize[2],
          fontWeight: theme.typography.customFontWeight[0],
          fontFamily: theme.typography.fontFamily,
          mr: isIndent ? "10px" : "22px",
          mt: 0.75,
        }}
      >
        <span>{label}</span>
        {
          tooltip && (
            <Tooltip title={tooltip} placement="bottom" arrow>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: 16,
                  marginLeft: 1,
                  '& img': {
                    content: `url(${icon_info})`,
                  },
                  '&:hover img': {
                    content: `url(${icon_info_hover})`,
                  },
                }}
              >
                <img src={icon_info} alt="" style={{ width: 16, height: 16, cursor: 'pointer' }} />
              </Box>
            </Tooltip>
          )
        }
        {isPro && (
          isUnityProSubscribed || !isProEnabled ? (
            <ProColorIcon
              aria-label="Pro"
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                marginLeft: 8,
                marginTop: -12,
                marginBottom: -12,
                flexShrink: 0,
              }}
            />
          ) : (
            <Tooltip
              title="Pro feature disabled"
              placement="bottom"
              arrow
            >
              <ProOrangeOutlineIcon
                aria-label="Pro"
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  marginLeft: 8,
                  marginTop: -12,
                  marginBottom: -12,
                  flexShrink: 0,
                }}
              />
            </Tooltip>
          )
        )}
      </Box>

      {children}
    </Box>
  );
};